import { render, staticRenderFns } from "./ProgramSelect.vue?vue&type=template&id=c924f4ee&"
import script from "./ProgramSelect.vue?vue&type=script&lang=ts&"
export * from "./ProgramSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports